import {
  SR_API_ACTION_APARTMENT_GET_LIST,
} from 'api/actionTypes';

export default async function getApartmentList({ state, apiClient }, { filters } = {}) {
  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_GET_LIST,
    state: state,
    payload: {
      page: 0,
      count: 1000,
      filters: filters,
    },
    onSuccess({ data }) {
      state.set(['apartments', 'list'], data);
    },
  });
}
